import axios from "axios";
import CheckHttp from "@/asyncs/MyHttpCheck.js";
import {
    Notify
} from "vant";
import Env from "@/logics/Envs.js";

export default async function (classId, dataObject, taskId) {
    try {
        const toSend = new FormData();
        toSend.append("classId", classId);
        toSend.append("json", JSON.stringify(dataObject));
        if (taskId) {
            toSend.append("taskId", taskId);
        }
        const res = await axios.post(Env.apiPath + "setClassTask", toSend);
        if (res.data.error) {
            Notify({
                type: "danger",
                message: res.data.error,
                duration: 5000
            });
            return null;
        }
        return res.data.task;
    } catch (err) {
        CheckHttp(err);
        return null;
    }
}